// extracted by mini-css-extract-plugin
export default {"divider":"EidsrIntegration_divider__MnYFS","header":"EidsrIntegration_header__tdsng","districtInput":"EidsrIntegration_districtInput__LrneD"};